import Err from '../../models/err';

export default function createLessThanEqualToError(attrName, value) {
  return new Err({
    code: Err.Code.LESS_THAN_OR_EQUAL_TO,
    attr: attrName,
    detail: `Value should be less than or equal to ${value}`,
  });
}
